module.exports = __webpack_public_path__ + "static/media/parkingimg.156a5c37.webp";